import { Controller } from "stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["modal"];

  open(event) {
    event.preventDefault();
    this.pendingForm = event.currentTarget.closest("form");
    if (!this.bsModal) {
      this.bsModal = new Modal(this.modalTarget);
    }
    this.bsModal.show();
  }

  confirm() {
    this.bsModal.hide();
    if (this.pendingForm) {
      this.pendingForm.submit();
      this.pendingForm = null;
    }
  }

  close() {
    this.bsModal?.hide();
    this.pendingForm = null;
  }
}
